import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalContext } from '../PharmacyModalContent';
import { MODAL } from '../../../constants';
import { addPharmacyNoteNew } from '../../../../../redux/notes/addNoteReducer';
import AddNoteComponent from './components/AddNoteComponent';

const AddNote = () => {
  const dispatch = useDispatch();
  const { isFetching, note } = useSelector((state) => state.addNote);
  const { setModalContent, pharmacyId } = React.useContext(ModalContext);
  const redirectToNotesListHandler = () => setModalContent(MODAL.NOTES_LIST);

  useEffect(() => {
    if (note) {
      setModalContent(MODAL.NOTES_LIST);
    }
  }, [note, setModalContent]);

  const handleSubmit = (text, e) => {
    e.preventDefault();
    dispatch(addPharmacyNoteNew(pharmacyId, text));
  };

  return (
    <AddNoteComponent
      handleSubmit={handleSubmit}
      isFetching={isFetching}
      handleGoToList={redirectToNotesListHandler}
    />
  );
};

export default AddNote;
